<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

/**
 * Login component
 */
export default {
   page: {
      title: "Login",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
   },
   data() {
      return {
         errors: {},
         email: '',
         password: '',    
         login_mobile: false,
         login_email: true,
         token: '',
         country_code:1,
         mobile:'',
         countries:[],
         show_password: false,
      };
   },
   created() {
         this.fetchCountryCodes();
      },
  
   methods: {
      onSubmit() {
    let data;

    if (this.login_email) {
        data = JSON.stringify({
            "username": this.email,
            "password": this.password
        });
    } else if (this.login_mobile) {
        data = JSON.stringify({
            "mobile": this.mobile,
            "country_code": this.country_code,
            "password": this.password
        });
    }

    const config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
    };

    this.errors = {};

    // Make the Axios request based on the login method
    let url = this.login_email ? "clinic/login/clinic" : "clinic/login/mobile";
    
    this.$axios.post(url, data, config)
        .then((response) => {
            const responseData = response.data.data;
            console.log(response.data);
            this.modules = responseData.modules;
            console.log(responseData);
            
            if (responseData.token) {
                localStorage.setItem('clinic_modules', JSON.stringify(responseData.modules));
                localStorage.setItem('medicino_clinic', JSON.stringify(responseData));
                localStorage.setItem('clinic_modules_names', JSON.stringify(responseData.module_names)); 
                this.token = responseData.token;
                this.fetchSettings();
                // Navigate to dashboard or handle success
                // this.$router.push({ name: "dashboard" });
                // this.$swal("", response.data.message, "success");
            } else {
                this.$swal("", "Failed to fetch token, please try again", "error");
            }
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                this.errors = error.response.data.message;
                this.$swal("", this.errors, "error");
            } else {
                this.errorMessage = error.message;
                this.$swal("", "Something went wrong", "error");
            }
        });
},
   togglePassword() {
      if(this.show_password == false) {
         this.show_password = true;
      } else {
         this.show_password = false;
      }
   },

     fetchCountryCodes() {
            let url = "api/admin/countries";         
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },
     fetchSettings() {
            let url = "clinic/settings";         
            //this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               var clinic = responseData.clinic;
               clinic.token = this.token;
               clinic.modules = this.modules;
               localStorage.setItem('medicino_clinic', JSON.stringify(clinic));

               this.$router.push({ name: "dashboard" });
               this.$swal("", "You have logged in successfully", "success");         
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         changeToMobile() {
            this.login_mobile = true;
            this.login_email = false;
            this.errors = {};
            this.email = '';
            this.password = '';
            this.mobile = '';
            this.country_code = 1;
         },
         changeToEmail() {
            this.login_mobile = false;
            this.login_email = true;
            this.errors = {};
            this.email = '';
            this.password = '';
            this.mobile = '';
            this.country_code = 1;
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
    }, 
        
   },
};
</script>

<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft bg-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">Welcome Back !</h5>
                           <p>Sign in to continue to MEDICINO-CLINIC</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                     <router-link tag="a" to="/">
                        <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-light">
                              <img src="@/assets/images/logo.png" alt height="90" />
                           </span>
                        </div>
                     </router-link>
                    <div class="d-flex justify-content-center mb-4">
                        <div class="highlight-box">
                           <span class="highlight-text">MEDICINO CLINIC</span>
                        </div>
                     </div>  
                  </div>   
                  <b-form class="p-2" @submit.prevent="onSubmit">
            
                        <!-- <b-form-group class="mb-3" id="input-group-1" label="Username" label-for="input-1">
                           <b-form-input id="input-1" v-model="email" type="text" placeholder="Enter username" :class="{ 'is-invalid': Boolean(errors.username)  }"></b-form-input>

                           <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>   
                  
                        </b-form-group> -->

                        <b-form-group class="mb-3" id="input-group-1" label="Email" label-for="input-1" v-if="this.login_email">
                           <b-form-input id="input-1" v-model="email" type="text" placeholder="Enter email" :class="{ 'is-invalid': Boolean(errors.username)  }"></b-form-input>

                           <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>   
                  
                        </b-form-group>
                        <div class="form-group col-md-12" v-if="this.login_mobile">
                           <label>Mobile Number <span class="text-danger">*</span></label>
                                 <b-input-group>
                                    <b-input-group-prepend>
                                       <select class="form-control" v-model="country_code">
                                          <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                       </select>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="mobile" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-input-group>
                                 
                        </div>

                        <!-- <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                           <b-form-input id="input-2" v-model="password" type="password" placeholder="Enter password" :class="{ 'is-invalid': Boolean(errors.password)  }"></b-form-input>

                           <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>   
                        </b-form-group> -->

                        <b-col md="12" class="form-group">
                        <label class="control-label">Password</label>
                        <b-input-group>
                              <b-form-input type="password" v-model="password" placeholder="Enter password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" placeholder="Enter password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>
               
                        <div class="mt-3 d-grid">
                           <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                        </div>
                     </b-form>
                     <div class="row justify-content-center align-items-center" style="height: 7vh;">
                           <div class="col-12 d-flex justify-content-center align-items-center">
                              <div class="p-2">
                                       <span class="ms-2 hover-blue" @click="changeToMobile" v-if="this.login_email">Login with Mobile</span>
                                       <span class="ms-2 hover-blue" @click="changeToEmail" v-else>Login with Email</span>                                    
                              </div>
                           </div>
                        </div>
               </div>
               <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="mt-5 text-center">
          
               <p>
                  © {{ new Date().getFullYear() }} MEDICINO.
               <!-- © {{ new Date().getFullYear() }} MEDICINO. Powered by Sigosoft -->

               </p>
            </div>
            <!-- end row -->
         </div>
         <!-- end col -->
      </div>
      <!-- end row -->
   </Layout>
</template>

<style>
.highlight-box {
   background-color: #f0f8ff; 
   padding: 4px 8px; 
   border-radius: 3px; 
   border: 1px solid #004080; 
   display: inline-block; 
   margin-top: -25px;
}

.highlight-text {
   color: #004080; 
   font-size: 0.875rem;
   font-weight: 500; 
}
</style>